export const msalConfig = {
  auth: {
      clientId: 'f3ad2154-7e10-4730-a055-8852ced42d47',
      authority: "https://login.microsoftonline.com/common",
      redirectUri: "https://live.heedify.io"
  },
  cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: false,
  }
};

  
  export const loginRequest = {
    scopes: ["User.Read"], 
  };